import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { parseStripeShopPriceList } from "./stripeShopTypes";

/** Prices for a single Stripe product, via the shop-prices proxy_read type. */
export const useShopStripePrices = (stripeKey: string | null, productId: string | null) => {
  const query = useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: {
      integration: "Stripe",
      type: "shop-prices",
      query: JSON.stringify({ stripeKey, productId, active: true, limit: 100 }),
    },
    enabled: !!stripeKey && !!productId,
    select: (response) => parseStripeShopPriceList(response.data),
  });

  return { prices: query.data?.data ?? [], isLoading: query.isLoading, error: query.error };
};
